import axios from "axios";
import { adminAPIInstance, axiosInstance, stageAdminAPIInstance } from "./axiosInstance";

export const blastToAllUsers = async (data) => {
  try {
    const blast = await axiosInstance.post("/announcement/send-announcements", data);

    if (blast) {
      return blast;
    }

    return [];
  } catch (error) {
    console.log(error);
  }
};

export const blastChatToAllUsers = async (data) => {
  try {
    const blast = await stageAdminAPIInstance.post("/notifier/broadcast/streamchat", data);

    if (blast) {
      return blast;
    }

    return [];
  } catch (error) {
    throw error
  }
};

export const blastEmailToAllUsers = async (data) => {
  try {
    // const blast = await stageAdminAPIInstance.post("/email/sendBlastTemplateEmail", data);
    const blast = await stageAdminAPIInstance.post("/email/sendBlastTemplateEmail", {
      subject: data.title,
      content: data.body,
      // to: "pcari.auto@gmail.com",
      img: data.image_url,
    });

    if (blast) {
      return blast;
    }

    return [];
  } catch (error) {
    throw error;
  }
};
